import { Component, signal, WritableSignal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ThemeService, ToastService } from '@toteimlib/angular-lib';
import { ApiService,ErrorResponse } from '@toteimlib/angular-lib';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { imports } from './onboarding.imports';
import * as faIcons from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-onboarding',
  imports: imports,
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss'
})
export class OnboardingComponent {

  protected readonly faIcons: any = faIcons;

  loading: WritableSignal<boolean> = signal(true);
  btn_loading: WritableSignal<boolean> = signal(false);
  valid_credentials: WritableSignal<boolean> = signal(false);
  error_message: WritableSignal<string> = signal('');
  lang: WritableSignal<string> = signal('');
  theme: WritableSignal<string> = signal('light');

  domain: string = '';
  client_id: string = '';

  formGroup: FormGroup = new FormGroup({
    acknowledgement_receipt: new FormControl(undefined, Validators.required),
    contact_email: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(private apiService: ApiService, private toastService: ToastService, private activatedRoute: ActivatedRoute, private themeService: ThemeService, private translateService: TranslateService) {
    this.domain = this.activatedRoute.snapshot.queryParams['domain'] || '';
    this.client_id = this.activatedRoute.snapshot.queryParams['client_id'] || '';

    this.setLang();
    this.setTheme();

    this.apiService.post('onboarding/provider', {
      client_id: this.client_id,
      domain: this.domain
    }, (_: any): void => {
      this.valid_credentials.set(true);
      this.loading.set(false);
    }, (res: ErrorResponse): void => {
      this.error_message.set(res.message || 'error.default');
      this.valid_credentials.set(false);
      this.loading.set(false);
    });
  }

  sendData(): void {
    this.formGroup.markAllAsTouched();

    if (this.formGroup.valid) {
      this.btn_loading.set(true);

      this.apiService.post('onboarding/token', {
        contact_email: this.formGroup.get('contact_email')?.value,
        acknowledgement_receipt: this.formGroup.get('acknowledgement_receipt')?.value
      }, (res: any): void => {
        window.parent.postMessage(res.data, 'https://' + this.domain);
        this.btn_loading.set(false);
      }, (res: ErrorResponse): void => {
        this.toastService.showError(res.message);
        this.btn_loading.set(false);
      });
    }
  }

  setTheme(): void {
    const theme: string = this.activatedRoute.snapshot.queryParams['theme'];

    this.theme.set(['light', 'dark'].includes(theme) ? theme : 'light');
    this.themeService.setTheme(this.theme());
  }

  setLang(): void {
    const lang: string = this.activatedRoute.snapshot.queryParams['lang'];

    this.lang.set(environment.langs.includes(lang) ? lang : 'fr');
    this.translateService.use(this.lang());
  }

}
